// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JsUoM","disabled":"Button_disabled__akevB","c-black":"Button_c-black__EVSGC","c-white":"Button_c-white__eKK+x"};